import { render, staticRenderFns } from "./JobSearchDesktop.vue?vue&type=template&id=4f830865&"
import script from "./JobSearchDesktop.vue?vue&type=script&lang=js&"
export * from "./JobSearchDesktop.vue?vue&type=script&lang=js&"
import style0 from "./JobSearchDesktop.vue?vue&type=style&index=0&id=4f830865&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports